export const ptBr_analyticTitle = {
  'analytic.name': 'Analytics',
  'analytic.notification.processing.report': 'O relatório está sendo processado. Quando terminado, o arquivo será enviado para seu e-mail {email}.',
  'analytic.see.chat': 'Ver chat',
  'analytic.btn.download.chat': 'Relatório de chat',
  'analytic.btn.summary.download.chat': 'Resumo',
  'analytic.tooltip.download.chat': 'Faça o download dos dados filtrados e/ou de todos os valores visíveis na tabela',
  'analytic.survey.binary': 'Binário',
  'analytic.survey.stars': 'Estrelas',
  'analytic.survey.1': '1',
  'analytic.survey.2': '2',
  'analytic.survey.3': '3',
  'analytic.survey.4': '4',
  'analytic.survey.5': '5',
  'analytic.survey.nps': 'NPS',
  'analytic.survey.positive': 'Positivo',
  'analytic.survey.positives': 'Positivo',
  'analytic.survey.neutral': 'Neutro',
  'analytic.survey.negative': 'Negativo',
  'analytic.survey.negatives': 'Negativo',
  'analytic.survey.promoters': 'Promotores',
  'analytic.survey.detractors': 'Detratores',
  'analytic.survey.csat': 'CSAT',
  'analytic.survey.none': 'Sem response',
  'analytic.feedback.positive': 'Feedback positivo',
  'analytic.feedback.negative': 'Feedback negativo',
  'analytic.transferred.by.evasives': 'Transferência por evasivas',
  'analytic.transferred.by.answer': 'Transferência por resposta',
  'analytic.other': 'Outros',
  'analytic.transferred.by.negative.feedback': 'Transferência por feedback negativo',
  'analytic.transferred.by.same.answer': 'Transferência por respostas iguais',
  'analytic.transferred.by.direct.derivation': 'Transferência direta',
  'analytic.transferred.by.answer.tool': 'Transferência por complemento',
  'analytic.retained.by.agentbot': 'Retido por AgentBot',
};
